import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42m2NsQqAIBQA/f/vi4hca7BXkYqYUV4UiIs33HRwikLONLjV52uPBH3gZ4doQUYhhVSDtEZ8t+Emi+kNMiycNtbgPzztxQsyYnzQ5o97pQAAAABJRU5ErkJggg=="};
